/**
 * DocumentHub.js
 * Created by calhosh on 8/28/2020.
 */
import _ from 'lodash';
import {labels} from '../../../util/utils';
import env from '../../../util/env';
import utility from '../../../util/utilityfunctions';
import {showChangeReasonModal} from '../../../actions/Document/fourFortyGlDocumentActions';

const initDocHelper = function(store) {
	return new Promise((resolve, reject) => {
		let SignalRDocHubLoaded = function() {
			return new Promise((resolve, reject) => {
				if (!window.jQuery.connection[env.getDocHelperConfig().hubName]) {
					return reject(['0010', 'Connection Failed', labels.documentHelperConnectionIssue]);
				}
				window.jQuery.extend(window.jQuery.connection[env.getDocHelperConfig().hubName].client, {
					uploadComplete: function(message) {
						const storeState = store.getState();

						// Get uploaded file data from the store
						let documentData;
						if (storeState.docHelperDocuments && storeState.docHelperDocuments) {
							documentData = storeState.docHelperDocuments[message.FileName + '_' + message.FileId];
						}

						// This happens only after uploading a file after editing it
						if ((!documentData || !documentData.isUserUpload) && message.FileVersion > 1) {
							if (storeState.fourFortyGlDocuments.documents) {
								const fourFortyDocumentData =
									storeState.fourFortyGlDocuments.documents.byId[message.FileId.toUpperCase()];

								const show440GLModal = utility.isChangeReasonRequired(
									storeState.engagement,
									storeState.quickLink,
									fourFortyDocumentData
								);

								const documentConnectionId = fourFortyDocumentData?.connectionId;
								const currentConnectionId = window.jQuery.connection[env.getDocHelperConfig().hubName].connection.id;

								// Document was uploaded within the current browser tab
								if (documentConnectionId === currentConnectionId) {
									store.dispatch(showChangeReasonModal(show440GLModal, message.FileId));
								}
							}
						}
						store.dispatch({
							type: 'KRONOS_DOCUMENT_UPLOAD_COMPLETE',
							meta: {message},
							engagementId: storeState.engagementId
						});
					},
					uploadError: function(message, Id) {},
					uploadProgress: function(message) {
						const storeState = store.getState();
						store.dispatch({
							type: 'KRONOS_DOCUMENT_UPLOAD_PROGRESS',
							meta: {message},
							engagementId: storeState.engagementId
						});
					},
					addDocumentError: function(message) {},
					addDocumentComplete: function() {
						console.log(' ✔✔ AddDocumentComplete : from DocumentHub');
					},
					downloadProgress: function(message) {},
					downloadComplete: function(message) {},
					downloadCanceled: function(message) {}
				});

				window.jQuery.connection.hub.url = env.getDocHelperConfig().SignalRHubUrl;
				if (!window.jQuery.connection[env.getDocHelperConfig().hubName]) {
					return reject(new Error('jQuery connnection to DocumentHub failed!'));
				}
				if (window.jQuery.connection) {
					window.jQuery.connection.hub
						.start()
						.done(() => {
							return resolve();
						})
						.fail((e) => {
							return reject(e);
						});
				} else {
					return reject(new Error('jQuery connection not available!'));
				}
			});
		};

		let updateState = function() {
			console.log(window.jQuery.signalR.connectionState);
		};
		let disconnect = function() {
			console.log(window.jQuery.signalR.connectionState);
			console.log('SignalR Hub Disconnected');
			//TODO: network error should be a promise reject to be handled

			_.delay(function() {
				window.jQuery.connection.hub.start();
			}, 10 * 1000);
		};
		// Updates View status when connection is lost
		let networkError = function() {
			console.log(window.jQuery.signalR.connectionState);
			console.log('SignalR Slow Connnection - Reconnecting');
		};
		let monitor = function() {
			console.log('SignalR Hub started');
			window.jQuery.connection.hub
				.stateChanged(updateState)
				.disconnected(disconnect)
				.connectionSlow(networkError);
			return resolve();
		};

		sessionStorage.removeItem('docHubDownloadCallbacksRegistered');
		sessionStorage.removeItem('docHubUploadCallbacksRegistered');
		window.jQuery
			.ajax({
				url: env.getDocHelperConfig().SignalRHubUrl,
				dataType: 'script',
				async: true
			})
			.done(() => {
				SignalRDocHubLoaded()
					.then(monitor)
					.catch((e) => {
						store.dispatch({
							type: 'DOCHELPER_ERROR',
							error: e
						});
						return reject(e);
					});
			});
	});
};

export default initDocHelper;
